import(/* webpackMode: "eager" */ "/codebuild/output/src3632624141/src/apps/webapp/src/app/global-error.tsx");
